import {LocationService} from "../../services/LocationService";
import {AssetService} from "../../services/AssetService";
import {Asset} from "../../entities/Asset";
import {Location} from "../../entities/Location";
import {NotificationService} from "../../services/NotificationService";

export class BatchMoveCtrl {
    $scope:any;
    locations:Location[];
    selectedLocation:Location;
    public static $inject = ['$scope','$uibModalInstance','LocationService', 'AssetService','assets','NotificationService'];
    constructor($scope:any, public modalInstance:angular.ui.bootstrap.IModalServiceInstance,
                public locationService:LocationService,
                public assetService:AssetService,
                public assets:Asset[],
                public notifyService:NotificationService) {
        this.$scope = $scope;
        $scope.vm = this;
        this.locationService.getAll().then((data)=>{
            this.locations = data;
            if(this.locations.length > 0)
                this.selectedLocation = this.locations[0];
        });
    }
    ok() {
        var ids:number[] = this.assets.map<number>((asset)=>asset.id);
        this.assetService.batchMove(ids, this.selectedLocation.id).then(()=>{
            this.notifyService.notify("Assets Moved Successfully");
            this.modalInstance.close(true);
        })
        .catch((exc)=>{
            this.notifyService.notifyError("Error moving assets",exc);
            this.modalInstance.dismiss('cancel');
        });
    }
    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
